import { WHITE_TRANSPARENT_LIGHT } from "./colors.es.js";
import { Spacing } from "./spacing.es.js";
const DEFAULT_ELEVATION = `${Spacing["0"]} ${Spacing["0"]} ${Spacing["1250"]} ${Spacing["0"]} ${WHITE_TRANSPARENT_LIGHT}`;
const NONE_ELEVATION = "none";
export {
  DEFAULT_ELEVATION,
  NONE_ELEVATION
};
//# sourceMappingURL=elevations.es.js.map
